import participantDefault from '@constants/participantDefault';

import makeStore from '../makeStore';

const initialState = {
  me: participantDefault,
  profileImageCache: new Map(),
  subClient: null,
  updating: '',
  rating: '',
  isOnline: false,
  isConnecting: false,
  finishedAppLoading: false,
  hideTopMenu: false,
  // user settings
  showFirstTimerTooltips: false,
  showGetStarted: false,
  enableNotePicture: true,
  enableNoteTags: false,
  enableNoteDate: false,
  enableNoteCategory: false,
  enableDailyQuoteNotifications: false,
  enablePricePlanNotifications: false,
  isSearchable: false,
  saveCard: false,
  tier: 'free'
};

const [ApplicationProvider, useApplicationStore] = makeStore(initialState);

export { ApplicationProvider, useApplicationStore };
